import React, { useState } from 'react';
import MainNav from '../../Components/MainNav.js';
import ProductItemCoach from '../../Components/ProductItemCoach';
import FooterCart from '../../Components/Footers';

import FiltersSection from 'registration/Components/FiltersSection.js';
// import SelectOptions from 'registration/Components/SelectOptions.js';
import { useSportEventList } from 'registration/queries/hooks.js';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { currentFormNumber } from 'registration/slices/registrationStepperSlice';
import ListLoader from 'components/ListLoader/index.js';
import FiltIcon from '../../Components/FilterIcon';
import Loader from 'components/Loader/index.js';

export default function userSportsEvents() {
  const [gender, setGender] = useState('All');
  const [ageCategory, setAgeCategory] = useState('All');
  const [sport, setSport] = useState('All');
  const [sportCategory, setSportCategory] = useState('All');
  const [filterStatus, setFilterStatus] = useState(false);
  const [weightCategory, setWeightCategory] = useState('All');

  const [selectedSport, setSelectedSport] = useState([]);

  const params = useParams();

  const sportEventListQueryData = useSportEventList({
    tournament_id: params.tournament_id,
    gender: gender ? (gender === 'All' ? '' : gender) : '',
    age_category: ageCategory ? (ageCategory === 'All' ? '' : ageCategory) : '',
    sport: sport ? (sport === 'All' ? '' : sport) : '',
    sport_category: sportCategory ? (sportCategory === 'All' ? '' : sportCategory) : '',
    weight_category: weightCategory ? (weightCategory === 'All' ? '' : weightCategory) : '',
  });

  const filterStatusHandler = () => {
    setFilterStatus(!filterStatus);
  };

  const history = useHistory();
  const dispatch = useDispatch();

  const sportEventsAddedList = useSelector((state) => state.modal);

  return (
    <>
      <MainNav />
      <div className="relative bg-white md:bg-gray-100 md:mt-8 mb-8 md:mb-48 w-full md:w-11/12 font-roboto m-auto flex gap-4 md:gap-0 flex-col md:flex-row justify-around text-sm">
        <div
          className={`fixed md:relative ${
            filterStatus ? 'block shadow-shadowPopup' : 'hidden md:block'
          } w-full md:w-80 z-10 md:z-0 bottom-0 md:static`}
        >
          <FiltersSection
            gender={gender}
            ageCategory={ageCategory}
            setGender={setGender}
            setAgeCategory={setAgeCategory}
            sport={sport}
            setSport={setSport}
            sportCategory={sportCategory}
            setSportCategory={setSportCategory}
            weightCategory={weightCategory}
            setWeightCategory={setWeightCategory}
            filterStatusHandler={filterStatusHandler}
          />
        </div>
        <div className="bg-white rounded-lg px-4 md:py-8 mb-24  w-full md:w-10/12 md:border border-gray-200">
          <div className="flex flex-col md:flex-row justify-between">
            {sportEventListQueryData.data && sportEventListQueryData.data.length > 0 ? (
              <div className="hidden md:block">
                <h2 className="font-bold text-xl">Sport and Sports Events</h2>
                <p className="text-sm mt-2 mb-5 text-gray-500">
                  SELECT THE SPORT & EVENT YOU WISH TO CREATE TEAMS FOR
                </p>
              </div>
            ) : null}
            <div className="flex justify-between md:justify-start my-2.5 items-center ">
              <h2 className="font-bold md:hidden">Sport Event List</h2>
              <div className="flex gap-6 items-center">
                <div className="md:hidden" onClick={filterStatusHandler}>
                  <FiltIcon
                    color={`${filterStatus ? 'rgba(93, 95, 239, 1)' : 'rgba(39, 39, 39, 0.38)'}`}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="">
            {sportEventListQueryData.data ? (
              sportEventListQueryData.data.length > 0 ? (
                <>
                  <span
                    className={`gap-2 md:gap-4 grid ${
                      sportEventListQueryData.data && sportEventListQueryData.data.length > 0
                        ? 'lg:grid-cols-2'
                        : 'lg:grid-cols-1'
                    } grid-cols-2 md:grid-cols-1 w-full`}
                  >
                    <ListLoader queryData={sportEventListQueryData} queryKey="id">
                      {({ item, index }) => {
                        return (
                          <ProductItemCoach
                            index={index}
                            sportName={item.sport}
                            eventName={item.sport_event}
                            icon=""
                            img={item.sport_image}
                            sportCategory={item.sport_category}
                            subCategory={item.sub_category}
                            gender={item.gender}
                            ageGroup={item.age_group}
                            price={item.price}
                            status={item.status}
                            statusDate={item.status_date}
                            teamsCreated={item.teams_created}
                            sportEventListQueryData={sportEventListQueryData}
                            selectedSport={selectedSport}
                            setSelectedSport={setSelectedSport}
                          />
                        );
                      }}
                    </ListLoader>
                  </span>

                  {/* <div className="flex md:hidden justify-between items-center gap-2 flex-wrap">
                    {' '}
                    <ListLoader queryData={sportEventListQueryData} queryKey="id">
                      {({ item, index }) => {
                        return (
                          <ProductItemMobile
                            index={index}
                            sportName={item.sport}
                            eventName={item.sport_event}
                            icon=""
                            img={item.sport_image}
                            sportCategory={item.sport_category}
                            subCategory={item.sub_category}
                            gender={item.gender}
                            ageGroup={item.age_group}
                            price={item.price}
                            status={item.status}
                            statusDate={item.status_date}
                            teamsCreated={item.teams_created}
                            sportEventListQueryData={sportEventListQueryData}
                            selectedSport={selectedSport}
                            setSelectedSport={setSelectedSport}
                          />
                        );
                      }}
                    </ListLoader>
                  </div> */}
                </>
              ) : (
                <div className="flex flex-col items-center mt-16 text-center w-full">
                  <p className="w-full text-center my-20 text-sm text-gray-750">
                    Your events for the Championship will be updated here
                  </p>
                  <p className="text-sm text-gray-650 w-2/5 mt-4 mb-70">
                    There was no sport event match to the filters applied. Remove some filters or
                    reset filters to get new results.
                  </p>
                </div>
              )
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </div>
      <FooterCart
        text="Continue to Registration"
        onClick={() => history.push(`/coach/registration/${params.tournament_id}/payment`)}
        events={sportEventsAddedList.columns.length}
        onPrevious={() => {
          dispatch(currentFormNumber());
          history.push(`/coach/registration/${params.tournament_id}/tournament-form`);
        }}
      />
    </>
  );
}
